import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Text } from 'components/Text'
import {
  ReviewsRoot,
  ReviewSection,
  ReviewCard,
  DogImageWrapper,
  RatingWrapper,
  MailWrapper,
  SectionTitle,
  MobileWrapper,
  CarouselItem,
  Comment,
  Spacer,
  BorderSpace,
  SectionWrapper,
  WaveSection,
} from './Reviews.styles'
import Trans from 'next-translate/Trans'
import Mail from '../../../../../public/assets/recipes/categories/mail-icon.png'
import Star from '../../../../../public/assets/recipes/categories/solid-star.svg'
import Image from 'next/image'
import { sliderSettings } from 'fixtures/slider'
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import Slider from 'react-slick'
import { BorderWave } from 'components/BorderWave'
import { ProductReviewType } from 'fixtures/review'
import { ColorTokens } from 'stitches.config'

type ReviewsProps = {
  icon?: boolean;
  reviews: ProductReviewType[];
  background: ColorTokens;
  cardColor?: ColorTokens;
}

export const Rating = () => (
  <RatingWrapper>
    <Image priority={true} src={Star} alt="" />
    <Image priority={true} src={Star} alt="" />
    <Image priority={true} src={Star} alt="" />
    <Image priority={true} src={Star} alt="" />
    <Image priority={true} src={Star} alt="" />
  </RatingWrapper>
)

export const Reviews = ({ icon = true, reviews, background, cardColor = 'accent-white' }: ReviewsProps) => {
  const { t } = useTranslation()

  return (
    <>
      <ReviewsRoot>
        {icon ? (
          <WaveSection>
            <BorderWave
              background={background}
              svgHeight="64px"
              bottom
              svgWidth="calc(144% + 1.3px)"
              path="M985.66,92.83C906.67,72,823.78,31,743.84,14.19c-82.26-17.34-168.06-16.33-250.45.39-57.84,11.73-114,31.07-172,41.86A600.21,600.21,0,0,1,0,27.35V120H1200V95.8C1132.19,118.92,1055.71,111.31,985.66,92.83Z"
            />
            <BorderSpace css={{ background: `$${background}` }} />
            <MailWrapper>
              <Image src={Mail} alt={t('recipes:overview.reviews.mail-icon')} />
            </MailWrapper>
          </WaveSection>
        ) : (
          <Spacer></Spacer>
        )}
        <SectionWrapper icon={icon} css={{ background: `$${background}` }}>
          <SectionTitle color="primary-500" align="center" weight="semiBold" size="h1" as="h2">
            {t('recipes:overview.reviews.title')}
          </SectionTitle>
          <ReviewSection>
            {reviews.map((item: ProductReviewType, index) => (
              <ReviewCard css={{background: `$${cardColor}`}} key={index}>
                <DogImageWrapper>
                  <Image priority={true} src={item.image} alt="" />
                </DogImageWrapper>
                <Rating />
                <Comment
                 author={(item.name === 'seth') ? item.name : 'default'}
                 >
                  <Trans i18nKey={item.comment} components={{ strong: <strong /> }} />
                </Comment>
                <Text transform='uppercase' align="center" color="accent-black" size={{'@initial': 'body', '@bp2': 'bodyLarge'}}>
                  — {t(item.owner)} —
                </Text>
              </ReviewCard>
            ))}
          </ReviewSection>
          <MobileWrapper>
            <Slider {...sliderSettings}>
              {reviews.map((item, index) => (
                <CarouselItem key={index}>
                  <ReviewCard>
                    <DogImageWrapper>
                      <Image priority={true} src={item.image} alt="" />
                    </DogImageWrapper>
                    <Rating />
                    <Comment 
                    author={(item.name === 'seth') ? item.name : 'default'}
                    >
                      <Trans i18nKey={item.comment} components={{ strong: <strong /> }} />
                    </Comment>
                    <Text align="center" color="accent-black" size="headline">
                      {t(item.owner)}
                    </Text>
                  </ReviewCard>
                </CarouselItem>
              ))}
            </Slider>
          </MobileWrapper>
        </SectionWrapper>
      </ReviewsRoot>
    </>
  )
}

Reviews.displayName = 'Reviews'
